// extracted by mini-css-extract-plugin
export default {"paginationLinks":"_13zmyd6"};